import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import { Request_Letter } from "../api/Request_Letter";

function LetterTable({ Arr_Bookings }) {
  const { logout } = StaffuseAuth();

  //
  function handleOpenVISAPage(e, obj_booking) {
    e.preventDefault();
    window.open(
      `/Student/login/${obj_booking._id}/${obj_booking?.MetaData?.Password}`,
      "_blank"
    );
  }

  //------------------send staff letter--------
  function handleRequestLetter(e, Letter, Attendee) {
    e.preventDefault();
    console.log("Requesting Letter: ", Letter, Attendee);
    e.target.disabled = true;
    e.target.style.backgroundColor = "grey";
    e.target.innerText = "Requested";
    //
    let newNote = {
      DateTime: new Date().toISOString(),
      Note: Letter + " Sent to Staff",
      Staff_ID: localStorage.getItem("Username"),
    };
    //
    Request_Letter(
      Attendee,
      Letter,
      [localStorage.getItem("Username")],
      [],
      newNote,
      logout
    );
  }

  //function that checks if, given an object called Attendee, it has a prop called Notes, which is an array, and there is an object in the array with a prop called "Note" that matches the string "VISA"
  function CheckForLetter(Attendee, Letter) {
    if (Attendee.Notes) {
      let Note = Attendee.Notes.find(
        (note) =>
          note.Note === Letter + " Sent to Attendee" ||
          note.Note === Letter + " Sent to Staff"
      );
      if (Note) {
        return true;
      }
    }
    return false;
  }

  //------------------send Attendee letter--------
  function handleSendLetter(e, Letter, Attendee) {
    e.preventDefault();
    console.log("Requesting Letter: ", Letter, Attendee);
    e.target.disabled = true;
    e.target.style.backgroundColor = "grey";
    e.target.innerText = "Requested";
    //
    let newNote = {
      DateTime: new Date().toISOString(),
      Note: Letter + " Sent to Attendee",
      Staff_ID: localStorage.getItem("Username"),
    };
    //
    //get all emails from the Contacts array that are not marked as "No" in the "active" field
    let Emails = Attendee.Contacts.filter((contact) => contact.active !== "No");
    //Now return just an array of the "Email" prop
    Emails = Emails.map((contact) => contact.Email);
    //check length
    if (Emails.length === 0) {
      //run an alert
      window.alert("No Emails to send to");
      return;
    } else {
      console.log("Emails");
      console.log(Emails);
      Request_Letter(
        Attendee,
        Letter,
        Emails,
        [localStorage.getItem("Username")],
        newNote,
        logout
      );
    }
  }
  return (
    <div
      style={{
        overflowX: "scroll",
        overflowY: "auto",
        maxHeight: "calc(100vh - 300px)",
      }}
    >
      <table id="BookingTable">
        <thead>
          <tr>
            <th>Name</th>
            <th>Programme Title</th>
            <th>Programme Date</th>
            <th>Programme Varient</th>
            <th>SEF Status</th>
            <th>Booking Status</th>
            <th>VISA Info Page</th>
            <th>Require VISA</th>
            <th>Has the student ever been refused a VISA</th>
            <th>
              Which country or countries has the VISA been rejected from
              previously
            </th>
            <th>When was the last time the students VISA was rejected</th>
            <th>Passport Name</th>
            <th>Passport Number</th>
            <th>Passport DOB</th>
            <th>Passport Nationality</th>
            <th>VISA - to me</th>
            <th>Acceptance - to me</th>
            <th>Acceptance with Payment Line - to me</th>
            <th>VISA - to attendee</th>
            <th>Acceptance - to attendee</th>
            <th>Acceptance with Payment Line - to attendee</th>
          </tr>
        </thead>
        <tbody>
          {Arr_Bookings.map((obj_booking, index) => (
            <>
              <tr key={index}>
                <td>
                  {obj_booking.BasicInfo?.First_Name || ""}{" "}
                  {obj_booking.BasicInfo?.Last_Name || ""}
                </td>
                <td>{obj_booking.BasicInfo?.ProgrammeTitle || ""}</td>
                <td>{obj_booking.BasicInfo?.ProgrammeDate || ""}</td>
                <td>{obj_booking.BasicInfo?.ProgrammeVarient || ""}</td>
                <td
                  style={{
                    textDecoration: "none",
                    backgroundColor: !obj_booking.SEFInfo?.SEF
                      ? "#d11212"
                      : obj_booking.SEFInfo?.SEF === "Incomplete"
                      ? "#d11212"
                      : obj_booking.SEFInfo?.SEF === "In_Progress"
                      ? "#0853b6"
                      : obj_booking.SEFInfo?.SEF === "Awaiting_Review"
                      ? "#f98007"
                      : obj_booking.SEFInfo?.SEF === "Complete"
                      ? "#06862f"
                      : "",
                  }}
                >
                  {obj_booking.SEFInfo?.SEF
                    ? obj_booking.SEFInfo?.SEF.replaceAll("_", " ")
                    : "Not Started"}
                </td>
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "#f1948a" }}>Removed</td>
                ) : obj_booking.MetaData?.Reserved === "Yes" ? (
                  <td style={{ backgroundColor: "#85c1e9" }}>Reserved</td>
                ) : (
                  <td style={{ backgroundColor: "#DAF7A6" }}>Confirmed</td>
                )}
                <td>
                  {obj_booking.MetaData?.Password ? (
                    <button onClick={(e) => handleOpenVISAPage(e, obj_booking)}>
                      Open SEF
                    </button>
                  ) : (
                    <>Password Needed to Open SEF</>
                  )}
                </td>
                <td>
                  {obj_booking.VISA?.Do_you_require_a_VISA_support_letter || ""}
                </td>
                <td>
                  {obj_booking.VISA
                    ?.Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK ||
                    ""}
                </td>
                <td>
                  {obj_booking.VISA
                    ?.Which_country_or_countries_has_the_VISA_been_rejected_from_previously ||
                    ""}
                </td>
                <td>
                  {obj_booking.VISA
                    ?.When_was_the_last_time_the_students_VISA_was_rejected ||
                    ""}
                </td>
                <td>{obj_booking.VISA?.Passport_Name || ""}</td>{" "}
                <td>{obj_booking.VISA?.Passport_Number || ""}</td>{" "}
                <td>{obj_booking.VISA?.Passport_DOB || ""}</td>{" "}
                <td>{obj_booking.VISA?.Passport_Nationality || ""}</td>{" "}
                {/* Send to staff */}
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "grey" }}></td>
                ) : (
                  <td>
                    <button
                      onClick={(e) =>
                        handleRequestLetter(e, "VISA", obj_booking)
                      }
                    >
                      Request
                    </button>
                  </td>
                )}
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "grey" }}></td>
                ) : (
                  <td>
                    <button
                      onClick={(e) =>
                        handleRequestLetter(e, "Acceptance", obj_booking)
                      }
                    >
                      Request
                    </button>
                  </td>
                )}
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "grey" }}></td>
                ) : (
                  <td>
                    <button
                      onClick={(e) =>
                        handleRequestLetter(e, "Acceptance_Pay", obj_booking)
                      }
                    >
                      Request
                    </button>
                  </td>
                )}
                {/* Send to attendee */}
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "grey" }}></td>
                ) : (
                  <td
                    style={{
                      backgroundColor: CheckForLetter(obj_booking, "VISA")
                        ? "green"
                        : "",
                    }}
                  >
                    <button
                      onClick={(e) => handleSendLetter(e, "VISA", obj_booking)}
                    >
                      Send to Atendee
                    </button>
                  </td>
                )}
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "grey" }}></td>
                ) : (
                  <td
                    style={{
                      backgroundColor: CheckForLetter(obj_booking, "Acceptance")
                        ? "green"
                        : "",
                    }}
                  >
                    <button
                      onClick={(e) =>
                        handleSendLetter(e, "Acceptance", obj_booking)
                      }
                    >
                      Send to Atendee
                    </button>
                  </td>
                )}
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "grey" }}></td>
                ) : (
                  <td
                    style={{
                      backgroundColor: CheckForLetter(
                        obj_booking,
                        "Acceptance_Pay"
                      )
                        ? "green"
                        : "",
                    }}
                  >
                    <button
                      onClick={(e) =>
                        handleSendLetter(e, "Acceptance_Pay", obj_booking)
                      }
                    >
                      Send to Atendee
                    </button>
                  </td>
                )}
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LetterTable;
